import type { IconName } from "@similarweb/icons";

export enum EBooleanSearchFilterTypes {
    URL = "url",
    KEYWORD = "keyword",
}

export interface IExactMatchFilterProps {
    exactURL: string;
    onFilterChange: (includeStrings?: string) => void;
    type?: EBooleanSearchFilterTypes;
    inputFieldTooltip?: string;
    inputIconName?: IconName;
    placeholderIconName?: IconName;
    inputFieldTitle?: string;
    trackingOnApply?: (includeStrings: string[], excludeStrings: string[]) => void;
    onTextfieldFocusTracking?: (state: string) => void;
    onBooleanClickTracking?: VoidFunction;
}

export interface IExactUrlFilterContentProps {
    selectedURL: string;
    handleChange: (value: string) => void;
    inputFieldTooltip: string;
    inputFieldTitle: string;
    inputHasError: boolean;
    errorMessage?: string;
    handleInputKeyUp: (event: KeyboardEvent) => void;
    onCancelClick: () => void;
    onApplyClick: () => void;
    isApplyButtonDisabled: boolean;
}
